@let currentMask = mask();
@if (currentMask) {
  <aw-dynamic-mask-form [mask]="currentMask"></aw-dynamic-mask-form>
}
